import * as types from '../../action-types';
import {uploadFile as initialState } from "../../initialState";

const uploadFile = (state=initialState, action) => {
  switch (action.type) {
    case types.UPLOAD_FILE_START:
      return {
        ...state,
        isLoading: true
      };
    case types.UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.UPLOAD_FILE_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.UPLOAD_FILE_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default uploadFile;
